import { gql, useMutation } from '@apollo/client';
import { PORTAL_EXPEDIENT_PDF_DTO } from "../../../../fragments";
export const GENERATE_PROGRAM_RECORD_DOCUMENT = gql`
  ${PORTAL_EXPEDIENT_PDF_DTO}
  mutation GenerateDocument($expedient_id: Long!) {
    programRecord_generateDocument(expedient_id: $expedient_id) {
      ...PortalExpedientPDFDTO
    }
  }
`;
export const useGenerateProgramRecordDocument = onCompleteQuery => {
  return useMutation(GENERATE_PROGRAM_RECORD_DOCUMENT, {
    errorPolicy: 'all',
    onCompleted({
      programRecord_generateDocument
    }) {
      if (onCompleteQuery) {
        onCompleteQuery(programRecord_generateDocument);
      }
    }
  });
};